const routes = {
  home: "/",
  launchApp: '/launch-app',
  notFound: "/404",
  productPage: "/product",
  whyMidlPage: "/why-midl",
  ecosystemPage: "/ecosystem",

  user: {
    userRole: "/user-role",
    normalUserPersonalInfoForm: "/user-personal-info",
    normalUserBankingInfoForm: "/user-banking-info",
    custodianPersonalInfoForm: "/custodian-personal-info",
    custodianBankingInfoForm: "/custodian-banking-info",
  },

  panel: {
    transferFunds: "/transfer-funds",
    custodian: {

      dashboard: "/custodian/dashboard",
      referral: "/custodian/referral",
      orders: "/custodian/orders",
      depositOrder: "/custodian/deposit-order",
      withdrawOrder: "/custodian/withdraw-order",
      collateral: "/custodian/collateral",
      withdraw: "/custodian/withdraw",
      transactions: "/custodian/transactions",
      switchAccount: "/custodian/switch-account",
      aboutUs: "/custodian/about-us",
      logout: "/custodian/Logout",
      settings: "/custodian/settings",
      disputedOrder: '/custodian/disputed-order',
      disputedResult: '/custodian/disputed-order-result',
      appealedOrder: '/custodian/appealed-order',
      appealedResult: '/custodian/appealed-order-result',
    },

    user: {
      home: "/user/dashboard",
      referral: "/user/referral",
      wallet: "/user/wallet",
      orders: "/user/orders",
      createOrder: "/user/createOrder",
      orderCreated: "/user/orderCreated",
      transactions: '/user/transactions',
      // transactionHistory: "/user/transactions",
      settings: "/user/settings",
      aboutUs: "/user/about-us",
      depositOrder: "/user/deposit-order",
      withdrawOrder: "/user/withdraw-order",
      disputedOrder: "/user/disputed-order",
      disputedResult: '/user/disputed-order-result',
      dummyRoute: '/user/jury',
      appealDummyRoute: '/user/tribunal',
      tribunalDashboard: '/user/tribunal-dashboard',
      appealedOrder: '/user/appealed-order',
      appealedResult: '/user/appealed-order-result',

    },

    jury: {
      dashboard: "/jury/dashboard",
      referral: "/jury/referral",
      orders: "/jury/orders",
      orderToVote: '/jury/vote-order',
      depositOrder: "/jury/deposit-order",
      withdrawOrder: "/jury/withdraw-order",
      stakeNow: "/jury/stake",
      settings: "/jury/settings",
      transactions: "/jury/transactions",
      aboutUs: "/jury/about-us",
    },

    tribunal: {
      dashboard: '/tribunal/dashboard',
      referral: '/tribunal/referral',
      appealOrder: '/tribunal/appeal-order',
      transactions: '/tribunal/transactions',
      settings: '/tribunal/settings'
    }
  },

  auth: {
    register: "/register",
    logIn: "/login",
    signUp: "/sign-up",
    resetPassword: "/reset-password",
    forgotPassword: "/forgot-password",
    passwordChanged: "/password-changed",
    phoneVerification: "/phone-verification",
    emailVerification: "/email-verification",
    securityVerification: "/security-verification",
    accountCreated: "/account-created",
  },

  // Uniswap-style DeFi surfaces (swap / pools / liquidity / positions). These
  // are user-facing production pages — formerly under a "/qa" prefix, renamed
  // to clean top-level paths. Privileged pool actions (create / pause) live in
  // the Admin Console, not here.
  defi: {
    swap: "/swap",
    liquidity: "/liquidity",
    pools: "/pools",
    poolDetail: "/pools/:poolId",
    positions: "/positions",
    position: "/positions/:tokenId",
  },

  admin: {
    root: "/admin",
  },
};

export default routes;
